// Module
var code = `<div class="jumbotron-surface service-announcements-surface">

  <div class="jumbotron-panel-head service-announcements-head">
    <div class="service-announcements-head-main" ng-click="ctrl.isCollapsed = !ctrl.isCollapsed">
      <i class="fas fa-fw service-announcements-chevron" aria-hidden="true"
        ng-class="{'fa-chevron-right': ctrl.isCollapsed, 'fa-chevron-down': !ctrl.isCollapsed}"></i>
      <span class="jumbotron-heading">Service Announcements</span>
      <span class="jumbotron-note service-announcements-count">{{ctrl.ServiceAnnouncements.length}} items</span>
    </div>

    <div class="service-announcements-actions">
      <button type="button" class="btn btn-sm btn-primary" ui-sref="manager.service-announcement-new"
        title="Write a new service announcement">
        <i class="fas fa-plus-circle" aria-hidden="true"></i> New
      </button>
    </div>
  </div>

  <div class="service-announcements-body" ng-show="!ctrl.isCollapsed">

    <div class="jumbotron-media-grid">
      <div class="jumbotron-media-tile"
        ng-repeat="item in ctrl.ServiceAnnouncements | orderBy:'name' track by item.id">
        <bulk-select class="jumbotron-media-tile-header" title="{{item.name}}" media-title="item.name"
          on-toggle="ctrl.toggleBulk(item.id)"></bulk-select>
        <div class="jumbotron-media-tile-content">
          <div class="jumbotron-media-tile-controls">
            <div class="jumbotron-media-tile-control d-grid" ng-if="ctrl.scene">
              <button type="button" class="btn btn-sm btn-outline-primary" ng-click="ctrl.addToScene(item.id)"
                ng-disabled="!ctrl.isSceneActive()">
                <i class="fas fa-plus-circle" aria-hidden="true"></i> Add to playlist
              </button>
            </div>
            <div class="jumbotron-media-tile-control service-announcements-meta d-flex justify-content-between align-items-center">
              <div>Headline: {{item.headline}}</div>
              <button type="button" class="btn btn-sm btn-outline-secondary"
                ui-sref="manager.service-announcement-edit({id:item.id})" aria-label="Edit {{item.name}}"
                title="Edit this announcement">
                <i class="fas fa-pencil" aria-hidden="true"></i>
              </button>
            </div>
            <div class="jumbotron-media-tile-control">
              <media-labels service-announcement-id="item.id"></media-labels>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
`;
// Exports
export default code;